import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const ServicesPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<div style="display: contents;">
<section class="section section--first">
    <div class="container">
        <div class="services">
            <div class="services__text content" v-html="this.struct[this.structKey].componentData.DESCRIPTION">
            </div>
            <div class="services__img">
                <picture>
                    <source type="image/avif" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/services.avif'">
                    <source type="image/webp" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/services.webp'">
                    <img :src="this.SITE_TEMPLATE_PATH + '/img/content/services.png'" alt="" title="" width="1000" height="667" fetchpriority="high">
                </picture>
            </div>
        </div>
    </div>
</section>
<section class="section section--first">
    <div class="container">
        <div class="services__list">

            <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="services__list-item">
                <div class="services__list-item-top">
                    <div class="services__list-item-icon" :class="{'no-photo': item.IMAGE === false}">
                        <img v-if="item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE" :alt="item.NAME" :title="item.NAME">
                        <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                    </div>
                    <a :href="item.LINK" class="services__list-item-name">
                        {{item.NAME}}
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </a>
                </div>
                <div class="services__list-item-text">
                    {{item.PREVIEW_TEXT}}
                </div>
            </div>

        </div>
    </div>
</section>
</div>
    `
}